import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Products } from '@grandvisionhq/api-client';
import { Loader } from '@grandvisionhq/common';
import { withApiConfig } from '@grandvisionhq/state';
import { getAttrValue } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import ConfigureContactLenses$1 from './ConfigureContactLenses.js';
import { getSortedPackageTypes } from './helpers/get-sorted-package-types.js';

const allowedAttributes = [
    'addition',
    'axis',
    'baseCurve',
    'color',
    'cylinder',
    'diameter',
    'power',
    'packageQuantity', 
];
const ConfigureContactLensesContainer = (props)=>{
    const { product: { masterVariant  } , clAndSolutionsMaxOrderableQuantity ,  } = useProductDetailContext();
    const [attributes1, setAttributes] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);
    const [packageTypes1, setPackageTypes] = React.useState([]);
    const [variantData, setVariantData] = React.useState([]);
    const variantGroup = String(getAttrValue(masterVariant, 'brandKey'));
    React.useEffect(()=>{
        const getLensData = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                const { productsUrl  } = props.apiConfig;
                try {
                    const lensData = yield Products.getContactLenses(productsUrl, {
                        variantGroup
                    });
                    return parseLensData(lensData);
                } catch (err) {
                    console.warn('No variant data provided', err);
                    setIsLoading(false);
                }
            });
            return function getLensData() {
                return _ref.apply(this, arguments);
            };
        }();
        getLensData();
    }, []);
    const parseLensData = (lensData)=>{
        const availableAttributes = {};
        const { contactLensesVariants , masterPackageType , packageTypes  } = lensData;
        contactLensesVariants.forEach(({ attributes  })=>{
            for (const key of Object.keys(attributes)){
                if (allowedAttributes.includes(key)) {
                    const value = attributes[key];
                    if (!availableAttributes[key]) {
                        availableAttributes[key] = {
                            selected: '',
                            values: new Set()
                        };
                    }
                    availableAttributes[key].values.add(value);
                }
            }
        });
        setAttributes(availableAttributes);
        setPackageTypes(getSortedPackageTypes(masterPackageType, packageTypes));
        setVariantData(contactLensesVariants);
        setIsLoading(false);
    };
    return isLoading ? /*#__PURE__*/ React.createElement(Loader, {
        className: "contact-lens-configurator__loader"
    }) : /*#__PURE__*/ React.createElement(ConfigureContactLenses$1, swcHelpers.extends({}, props, {
        maxOrderableQuantity: clAndSolutionsMaxOrderableQuantity,
        attributes: attributes1,
        packageTypes: packageTypes1,
        variantData: variantData
    }));
};
var ConfigureContactLenses = withApiConfig(ConfigureContactLensesContainer);

export { ConfigureContactLensesContainer, ConfigureContactLenses as default };
//# sourceMappingURL=ConfigureContactLensesContainer.js.map
